import { useCallback, useRef } from 'react'

import { useDebounce } from '@/hooks'
import { Block, Label, FieldMessage } from '@/forms-legacy'

import { NumericInput } from './NumericInput'

interface Props {
  label: string
  value: number
  onChange: (label: string, value: number) => void
  error?: string
  testId?: string
  disabled?: boolean
}

export function DynamicLoadField(props: Props) {
  const { error, testId, label, value, onChange, disabled } = props

  const inputRef = useRef(null)

  const handleOnChangeValue = useCallback(
    (value: number) => {
      onChange(label, value)
    },
    [onChange, label],
  )

  const [debounceValue, debounceOnChange] = useDebounce({
    value,
    onChange: handleOnChangeValue,
    delay: 300,
  })

  return (
    <Block error={!!error} data-testid={testId} data-trackid={testId}>
      <Label>{label}</Label>
      <NumericInput
        name={label}
        onChange={debounceOnChange}
        value={debounceValue}
        innerRef={inputRef}
        disabled={disabled}
      />

      {!!error && <FieldMessage error>{error}</FieldMessage>}
    </Block>
  )
}
